import { render, staticRenderFns } from "./inventum.vue?vue&type=template&id=55f995e5&scoped=true&"
import script from "./inventum.vue?vue&type=script&lang=js&"
export * from "./inventum.vue?vue&type=script&lang=js&"
import style0 from "./inventum.vue?vue&type=style&index=0&id=55f995e5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f995e5",
  null
  
)

export default component.exports